import { Site } from '@envato/foundation-types'

const experimentConfig = {
  categoryRedesignAJPhase2Experiment: {
    experimentId: 'TgTNWsiYTvGLI0COC-6iqQ',
    running: true,
    loadingCover: true,
    sites: [Site.audiojungle],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      }
    }
  },
  categoryRedesignCCPhase2Experiment: {
    experimentId: '5p9h_BDAROmGAQYmmamDew',
    running: true,
    loadingCover: true,
    sites: [Site.codecanyon],
    variants: {
      0: {
        categoryPageBlocksB: false
      },
      1: {
        categoryPageBlocksB: false
      },
      2: {
        categoryPageBlocksB: true
      },
      3: {
        categoryPageBlocksB: true
      }
    }
  },
  authorDiscountingItemsPhase1: {
    experimentId: '8fSYJ-h4SXe9wcfdM8EBUQ',
    running: true,
    loadingCover: true,
    sites: [Site.themeforest],
    variants: {
      0: {
        showPromoItemsBlock: false,
        showWasNowPricing: false
      },
      1: {
        showPromoItemsBlock: false,
        showWasNowPricing: false
      },
      2: {
        showPromoItemsBlock: true,
        showWasNowPricing: false
      },
      3: {
        showPromoItemsBlock: true,
        showWasNowPricing: false
      },
      4: {
        showPromoItemsBlock: true,
        showWasNowPricing: true
      },
      5: {
        showPromoItemsBlock: true,
        showWasNowPricing: true
      }
    }
  },
  categoryPageElementsBlockVH: {
    experimentId: 'neL6UBl6QM-075iakKCxUA',
    running: true,
    loadingCover: true,
    sites: [Site.videohive],
    variants: {
      0: {
        categoryPageBlocksB: false
      },
      1: {
        categoryPageBlocksB: false
      },
      2: {
        categoryPageBlocksB: true
      },
      3: {
        categoryPageBlocksB: true
      },
      4: {
        categoryPageBlocksB: true
      },
      5: {
        categoryPageBlocksB: true
      }
    }
  },
  categoryPageElementsBlockGR: {
    experimentId: '-nbomKMpRo-o422kNe1jpg',
    running: false,
    loadingCover: true,
    sites: [Site.graphicriver],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      }
    }
  },
  categoryPageElementsBlockTF: {
    experimentId: 'tDmLiaB-RACY6uDAIrm2aQ',
    running: false,
    loadingCover: true,
    sites: [Site.themeforest],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      6: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      },
      7: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      }
    }
  },
  categoryPageElementsBlockCC: {
    experimentId: 'MAQHi6cdSBO4n4x5qBV8Zg',
    running: false,
    loadingCover: true,
    sites: [Site.codecanyon],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      6: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      },
      7: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      }
    }
  }
}

export default experimentConfig
